 <template>
<div class="bodyClient"> 
<div class="backgroundImage">
  <img
  class="imageClient" 
  :src="backgroundLoginClient"
  alt="Dragon"
  />
</div>
  <div class="panel panel-default panelDefaultClient">
    <div class="panel-body panelBodyClient">
      <img   
          style="align-self: center;"
          :src="clientLogoLogin"
          alt="Dragon"
      />
      <h2 class="text-center titleClient" style="margin-bottom:20px; margin-top:58px;">Password Reset</h2>
      <p v-if="isSent" class="text-center">
        We have sent you an email to reset your<br>
        password. For any further assistance, please<br>
        contact <u>admin@thedragongroup.com.au</u>
      </p>
      <p v-else data-v-c7f1a86c="" class="text-center subTitle">
        Enter your email address and we will send you a link to reset your password.
      </p>
      <div v-if="!isSent" class="divForm"> 
        <form class="login formStyleClient">
          <div class="form-group">
            <label style="margin-top: 11px;" id="id_email">Email address</label>
            <input class="form-control" id="id_email" v-model="email" type="text" value="">
          </div>
          <small class="text-danger" v-if="hasError" style="position: absolute; margin-top: -12px;">
            <img class="error" :src="errorClient">
            <strong style="color:#CC0000;">The email address does not have an active account</strong>
          </small>
          <button class="btn btn-primary btn-block buttonClient" :disabled="isLoading" @click="submitForm">
              <strong>Continue</strong>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export default {
  data () {
    return {
      backgroundLoginClient: this.$parent.$el.dataset.backgroundLoginClient,
      clientLogoLogin: this.$parent.$el.dataset.clientLogoLogin,
      errorClient: this.$parent.$el.dataset.errorClient,
      urlForget: this.$parent.$el.dataset.urlForget,
      isLoading: false,
      hasError: false,
      email: '',
      isSent: false,
    }
  },
  methods: {
    submitForm () {
      this.hasError = false
      this.isLoading = true
      axios.post(this.urlForget, {email: this.email}).then((response) => {
        this.isLoading = false
        this.isSent = true
        this.hasError = false
      }).catch(error => {
        console.log(error)
        this.isLoading = false
        this.hasError = true
      })
    },
  },
}
</script>

<style scoped>
.bodyClient {
  margin-top: -85px;
  width: 100%;
  height: 100%;
  padding-top: 0px !important;
  display: flex;
  padding-top: 80px;
  justify-content: center;
  align-items: center;
}
.backgroundImage {
  margin-top: 80px;
    display:flex;
    background: linear-gradient(
        180deg, rgba(180, 34, 34, 0.705882) 0%,
        rgba(255, 255, 255, 0) 100%);
  position: absolute;
  height: inherit;
  width: 100vw;
}
.imageClient {
  align-self:
  flex-end;
  z-index: -999;
  width: 100vw;
  opacity: 0.4;
}
.panelDefaultClient {
  margin-top: 80px;
  border-radius: 20px;
  opacity: 0.8;
  background: #FFF;
}
.panelBodyClient {
  padding-top: 85px;
  width: 630px;
  height: 700px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
}
.titleClient {
  font-weight: bold;
  font-size: 20px;
  color: #000;
}
.formStyleClient {
  color: #000;
  font-family: Arial;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.forgotPassword{
  color: #C00;
  text-align: center;
  font-family: Arial;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.divForm {
  align-self: center;
  width: 330px;
  flex-shrink: 0;
}
.buttonClient {
  margin-top: 49px;
  height: 47.072px;
  border-radius: 27.5px;
  background: #C00;
}
.subTitle {
  margin-left: 23%;
  margin-right: 23%;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/client_forget/App.vue